module.exports = __webpack_public_path__ + "img/logo.ade5c253.png";